import { Injectable } from '@angular/core';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Authorize } from '../models/authorize';
import { of } from 'rxjs';
import { UtilsService } from '../../shared/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizeEntityService extends BaseEntityService<Authorize> {

  constructor(
    private utilsService: UtilsService,
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'authorize', plural: 'authorize' },
      routerParamsService
    );
    this.nameId = 'authorizeId';
  }

  getAutorize(queryParams: Record<string, any>) {
    if (isMock) {
      return of(mockAutorize);
    }
    return this.httpClient.get(`${ this.entityUrl }`, { params: queryParams });
  }

  postAutorize(queryParams: Record<string, any>) {
    const body: Record<string, any> = this.utilsService.convertKeysToCamelCase(queryParams)
    return this.httpClient.post(`${ this.entityUrl }`, body);
  }

}

const isMock = false;


const mockAutorize: Authorize = {
  id: 102938,
  authClient: {
    prettyName: 'Airtable for ChatGPT',
    logo: 'https://mar-static.s3.us-east-2.amazonaws.com/auth-client-logo/chatgpt-app.webp',
    termsOfUse: 'https://chatgpt.com/terms',
    privacyPolicy: 'https://chatgpt.com/privacy',
    requiredRoles: [
      { description: 'Ler seus dados básicos de perfil' },
      { description: 'Acessar e editar suas tabelas' },
      { description: 'Criar novos registros no banco de dados' }
    ],
  },

  person: {
    id: 5678,
    document: '123.456.789-00',
    personProperties: {
      name: 'Maria da Silva'
    }
  },
  redirectTo: 'https://chatgpt.com/auth/callback'
};
